import { useState, useEffect } from "react";
import "./inputBox.css"

export default function InputBox(props: any) {
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    // create the media query list
    const mql = window.matchMedia("(max-width: 500px)");
    // set initial value
    setIsSmallScreen(mql.matches);

    // handler to update on resize
    const handler = (e: MediaQueryListEvent) => setIsSmallScreen(e.matches);
    mql.addEventListener("change", handler);

    return () => {
      mql.removeEventListener("change", handler);
    };
  }, []);

  // raw placeholder
  const raw = props.placeholder ?? "";

  // only truncate on small screens
  const labelText =
    isSmallScreen && raw.length > 30
      ? raw.substring(0, 27).trimEnd() + "…"
      : raw;

  return (
    <div className="relative">
      <input
        value={props.value}
        onChange={props.onChange}
        type="text"
        id={props.id}
        className="
          profileSectionInputBox
          px-2.5 
          pb-2.5 
          pt-3 
          w-[100%] 
          text-[16px]
          rounded-[5px] 
          focus:outline-none peer"
        placeholder=" "
      />
      <label
        htmlFor={props.id}
        className="
          profileSectionInputBoxLabel
          absolute text-[16px] 
          duration-300
          transform -translate-y-4 scale-75 top-2 z-10
          origin-[0] px-2
          peer-focus:px-2
          peer-placeholder-shown:scale-100
          peer-placeholder-shown:-translate-y-1/2
          peer-placeholder-shown:top-1/2
          peer-focus:top-2
          peer-focus:scale-75
          peer-focus:-translate-y-4
          rtl:peer-focus:translate-x-1/4
          rtl:peer-focus:left-auto start-1"
      >
        {labelText}
        {props.showAsterisk && <span className="text-[#FF2828]">*</span>}
      </label>
    </div>
  );
}
